module.exports = __webpack_public_path__ + "img/call-decline.6643c596.svg";